import { Injectable } from '@angular/core';
import { ContextService } from 'projects/cross-study-portal-lib/src/public-api';
import * as PermissionIds from './PermissionIds';

@Injectable({
  providedIn: 'root',
})
export class PermissionService {
  constructor(private context: ContextService) { }

  canManageRoles(): boolean {
    return this.hasPermissions(PermissionIds.PERMISSION_MANAGE_ROLES);
  }

  canManageUsers(): boolean {
    return this.hasPermissions(PermissionIds.PERMISSION_MANAGE_USERS);
  }

  canReadSites(): boolean {
    return this.hasPermissions(PermissionIds.PERMISSION_SITES_READ);
  }

  canEditSites(): boolean {
    return this.hasPermissions(PermissionIds.PERMISSION_SITES_EDIT);
  }

  hasCtmsAccessPermission(): boolean {
    return this.hasPermissions(PermissionIds.PERMISSION_CTMS_ACCESS);
  }

  private hasPermissions(permssionId: string): boolean {
    return this.context.instance.permissions?.some(x => x.id.toUpperCase() === permssionId.toUpperCase() && x.value > 0) || false;
  }
}
